import { getAllRecipients } from './getAllRecipientsAsEmailAddressStrings';
import { getFromAddress } from './getFromAddresses';
import ComposeViewState from '../store/schema/ComposeViewState';
import { AttachmentState } from 'owa-attachment-full-data';
import Message from 'owa-service/lib/contract/Message';
import createSmimeDefaultViewState from 'owa-smime/lib/utils/createSmimeDefaultViewState';
import { AddSmimePropertiesRequest } from 'owa-smime/lib/utils/tryAddSmimeProperties';

/**
 * Returns the AddSmimePropertiesRequestObject
 * @param viewState composeViewState of the current smime compose
 * @param message message object needs to sent to control
 * @param isSend true - if send, false - if save
 */
export default function getAddSmimePropertiesRequestObject(
    viewState: ComposeViewState,
    message: Message,
    isSend: boolean
): AddSmimePropertiesRequest {
    const smimeViewState = viewState.smimeViewState || createSmimeDefaultViewState();
    const {
        shouldSignMessageAsSmime,
        shouldEncryptMessageAsSmime,
        signingCertRawData,
    } = smimeViewState;
    const { docViewAttachments, inlineAttachments } = viewState.attachmentWell;
    let attachments: AttachmentState[];

    attachments = docViewAttachments.slice(0);
    attachments.push(...inlineAttachments);
    return {
        shouldSignMessageAsSmime,
        shouldEncryptMessageAsSmime,
        message,
        fromAddress: getFromAddress(),
        isSend,
        composeId: viewState.composeId,
        signingCertRawData,
        allRecipients: getAllRecipients(viewState),
        attachments,
    };
}
